import { render, staticRenderFns } from "./AdminSearchReports.vue?vue&type=template&id=e8b350bc&scoped=true&"
import script from "./AdminSearchReports.vue?vue&type=script&lang=js&"
export * from "./AdminSearchReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminSearchReports.vue?vue&type=style&index=0&id=e8b350bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b350bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8b350bc')) {
      api.createRecord('e8b350bc', component.options)
    } else {
      api.reload('e8b350bc', component.options)
    }
    module.hot.accept("./AdminSearchReports.vue?vue&type=template&id=e8b350bc&scoped=true&", function () {
      api.rerender('e8b350bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminSearchReports.vue"
export default component.exports